import React, {Component} from 'react'
import {connect} from 'react-redux'
import Button from '@material-ui/core/Button'
import { withStyles } from '@material-ui/core/styles'
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableHead from '@material-ui/core/TableHead'
import TableRow from '@material-ui/core/TableRow'
import TableFooter from '@material-ui/core/TableFooter'
import Paper from '@material-ui/core/Paper'
import Dialog from '@material-ui/core/Dialog'
import DialogContent from '@material-ui/core/DialogContent'
import DialogActions from '@material-ui/core/DialogActions'
import Tooltip from '@material-ui/core/Tooltip'
import Grid from '@material-ui/core/Grid'
import IconButton from '@material-ui/core/IconButton'
import ClearIcon from '@material-ui/icons/Clear'
import ModeEditIcon from '@material-ui/icons/ModeEdit'
import _ from 'lodash'
import E from 'wangeditor'
import { reduxForm} from 'redux-form'
import ReactSelect from 'react-select';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Pagination from '../../../../../uis/pagination'
import NoData from '../../../../../uis/noData'
import * as actions from '../reducers/list'
import EnhancedFilterField from '../../../../../uis/enhancedFilterFiled';
import Select from '../../../../../uis/form/select'
import Datetime from '../../../../../uis/form/datetime'
import dateFormat from '../../../../../util/dateFormat'
import * as http from '../../../../../util/http'

const styles = theme => ({
    root: {
        width: '100%',
        marginTop: theme.spacing.unit * 3,
        overflowX: 'auto',
    },
    table: {
        minWidth: 700,
    },
    dialogContent: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center'
    },
    textField: {
        width: 300,
        margin: theme.spacing.unit
    },
    doubleTextField: {
        width: (300 * 2) + (theme.spacing.unit * 4),
        margin: theme.spacing.unit * 2
    },
    dislogActions: {
        display: 'flex',
        justifyContent: 'space-around',
        margin: theme.spacing.unit * 3
    },
    contentCell: {
        maxWidth: 100,
        whiteSpace: 'noWrap',
        textOverflow: 'ellipsis',
        overflow: 'hidden'
    },
    group: {
        margin: `${theme.spacing.unit}px 0`,
        flexDirection: 'row'
    },
})

const validate = values => {
    const errors = {}
    
    if (!values.described) {
        errors.described = '必填'
    }
    if (!values.currentAccountId) {
        errors.currentAccountId = '必填'
    }

    return errors
}

class AddDialog extends React.Component {
    initWangeditor(inputElement, name, change) {
        if (!this[name]) {
            this[name] = new E(inputElement)
            // 配置服务器端地址
            this[name].customConfig.uploadImgServer = '/api/upload/img'
            this[name].customConfig.uploadFileName = 'files'
            this[name].customConfig.uploadImgMaxSize = 5 * 1024 * 1024;
            this[name].customConfig.uploadImgMaxLength = 5;
            this[name].customConfig.uploadImgHeaders = {
                'token': http.getUserInfo().token
            }
            // 使用 onchange 函数监听内容的变化，并实时更新到 state 中
            this[name].customConfig.onchange = html => {
                change(name, html);
            }
            this[name].create()
        }
    }
    handleLabelsChange = (selectOption) => {
        const {change} = this.props;
        console.info(selectOption);
        change('currentAccountId', selectOption.id)
        change('currentAccountName', selectOption.name)
    }
    render() {
        const {classes, dispatch, showModal, pristine, submitting, handleSubmit, change, alls} = this.props
        return (<Dialog
            open={showModal.add}
            onClose={() => dispatch({type: actions.HIDE_MODAL})}
            maxWidth="md"
            fullWidth
        >
            <form onSubmit={(handleSubmit)} noValidate autoComplete="off">
                <DialogContent className={classes.dialogContent}>
                    
                    <div className={classes.doubleTextField} style={{width: '100%'}} ref={el => this.initWangeditor(el, 'described', change)}></div>

                    <div style={{width: '100%'}}>
                        <ReactSelect
                            placeholder={'请输入执行人*'}
                            onChange={this.handleLabelsChange}
                            options={alls}
                        />
                    </div>
                    
                    <Select name="type" label="类型" placeholder="请输入类型" className={classes.doubleTextField} style={{width: '100%'}} required={true} data={[{"name":"普通","value":"普通"},{"name":"紧急","value":"紧急"}]}/>

                    <Datetime name="dueTime" label="截至日期" placeholder="请输入截至日期" className={classes.doubleTextField} style={{width: '100%'}} required={true}/>
                    
                </DialogContent>
                <DialogActions className={classes.dislogActions}>
                    <Button variant="outlined" onClick={() => dispatch({type: actions.HIDE_MODAL})}>取消</Button>
                    <Button type="submit" variant="outlined" color="primary" disabled={pristine || submitting}>确定</Button>
                </DialogActions>
            </form>
        </Dialog>)
    }
}
class UpdateDialog extends Component {
    initWangeditor(inputElement, name, change) {
        const {initialValues} = this.props;
        if (!this[name]) {
            this[name] = new E(inputElement)
            // 配置服务器端地址
            this[name].customConfig.uploadImgServer = '/api/upload/img'
            this[name].customConfig.uploadFileName = 'files'
            this[name].customConfig.uploadImgMaxSize = 5 * 1024 * 1024;
            this[name].customConfig.uploadImgMaxLength = 5;
            this[name].customConfig.uploadImgHeaders = {
                'token': http.getUserInfo().token
            }
            // 使用 onchange 函数监听内容的变化，并实时更新到 state 中
            this[name].customConfig.onchange = html => {
                change(name, html);
            }
            this[name].create()
            this[name].txt.html(initialValues[name])
        }
    }
    handleLabelsChange = (selectOption) => {
        const {change} = this.props;
        console.info(selectOption);
        change('currentAccountId', selectOption.id)
        change('currentAccountName', selectOption.name)
    }
    render() {
        const {classes, dispatch, showModal, pristine, submitting, handleSubmit, change,initialValues, alls} = this.props
        return (<Dialog
            open={showModal.update}
            onClose={() => dispatch({type: actions.HIDE_MODAL})}
            maxWidth="md"
            fullWidth
        >
            <form onSubmit={(handleSubmit)} noValidate autoComplete="off">
                <DialogContent className={classes.dialogContent}>
                    
                    <div className={classes.doubleTextField} style={{width: '100%'}} ref={el => this.initWangeditor(el, 'described', change)}></div>

                    <div style={{width: '100%'}}>
                        <ReactSelect
                            placeholder={'请输入执行人*'}
                            defaultValue={alls.find(item => item.value === initialValues.currentAccountId)}
                            onChange={this.handleLabelsChange}
                            options={alls}
                        />
                    </div>
                    
                    <Select name="type" label="类型" placeholder="请输入类型" className={classes.doubleTextField} style={{width: '100%'}} required={true} data={[{"name":"普通","value":"普通"},{"name":"紧急","value":"紧急"}]}/>

                    <Datetime name="dueTime" label="截至日期" placeholder="请输入截至日期" className={classes.doubleTextField} style={{width: '100%'}} required={true}/>
                    
                    <Select name="status" label="状态" placeholder="请输入状态" className={classes.doubleTextField} style={{width: '100%'}} data={[{"name":"新增","value":"新增"},{"name":"完成","value":"完成"},{"name":"作废","value":"作废"}]}/>
                </DialogContent>
                <DialogActions className={classes.dislogActions}>
                    <Button variant="outlined" onClick={() => dispatch({type: actions.HIDE_MODAL})}>取消</Button>
                    <Button type="submit" variant="outlined" color="primary" disabled={pristine || submitting}>确定</Button>
                </DialogActions>
            </form>
        </Dialog>)
    }
}

class DeleteDialog extends Component {
    render() {
        const {dispatch,showModal} = this.props
        return (<Dialog
            open={showModal.delete}
            onClose={() => dispatch({type: actions.HIDE_MODAL})}
            fullWidth
        >
            <DialogContent>确定删除吗？</DialogContent>
            <DialogActions>
                <Button variant="outlined" onClick={() => dispatch({type: actions.HIDE_MODAL})}>取消</Button>
                <Button variant="outlined" color="primary" onClick={() => dispatch(actions.remove(showModal.id))}>确定</Button>
            </DialogActions>
        </Dialog>)
    }
}

const AddFormDialog = connect(
    state => {
        return {
            initialValues: {
                type: '普通',
                dueTime: dateFormat(new Date(Date.now() + 24 * 3600 * 1000), 'yyyy-MM-dd'), 
            }
        }
    },
)(reduxForm({
    form: 'todoTaskAddForm',
    validate
})(AddDialog))

const UpdateFormDialog = connect(
    state => ({
      initialValues: {
        ...state.todoTask.detail,
        dueTime: dateFormat(new Date(state.todoTask.detail.dueTime), 'yyyy-MM-dd'), 
      }
    }),
  )(reduxForm({
    form: 'todoTaskUpdateForm'
})(UpdateDialog))

class TodoTask extends Component {
    componentDidMount() {
        const {dispatch}  = this.props
        dispatch(actions.getList())
        dispatch(actions.getAlls())
    }
    onPageClick = (index) => {
        const {dispatch,page} = this.props
        dispatch({
            type: actions.CHANGE_PAGE,
            page: {...page, index}
        })
        dispatch(actions.getList())
    }
    handleFiltersClick = (value) => {
        const { dispatch,filterList } = this.props
        const valueItem = filterList.find(item=>item.value === value);
        valueItem.isShow = !valueItem.isShow;
        dispatch({type: actions.CHANGE_FILTER_LIST,value: _.clone(filterList)})
    }
    cancelFiltersClick = (value) => {
        const { dispatch, query } = this.props
        this.handleFiltersClick(value);
        if (query[value]) {
            dispatch({type: actions.CHANGE_QUERY, key: value, value: null})
            dispatch(actions.getList())
        }
    }
    changeQuery = (e,name) => {
        const {dispatch} = this.props;
        dispatch({type: actions.CHANGE_QUERY,key: name,value: e.target.value})
        dispatch(actions.getList())
    }
    render() {
        const {classes, dispatch, list, page, total ,permissionMap, query, filterList, showModal} = this.props;
        return (
            <div>
                <Grid container spacing={8} alignItems="baseline" style={{justifyContent: 'space-between'}}>
                    <Grid item>
                        {permissionMap['待办事项_新增'] && <Button variant="outlined" color="secondary" onClick={() => dispatch({type: actions.SHOW_MODAL,key: 'add'})}>新增</Button>}
                    </Grid>
                </Grid>
                <Grid container spacing={8}>
                    <FormControl component="fieldset" className={classes.formControl}>
                        <RadioGroup
                            name="status"
                            className={classes.group}
                            value={query.status}
                            onChange={(e) => this.changeQuery(e,'status')}
                        >
                            <FormControlLabel value="" control={<Radio checked={!query.status} />} label={<p>全部<span style={{color: 'red'}}></span></p>} />
                            <FormControlLabel value="新增" control={<Radio />} label={<p>新增<span style={{color: 'red'}}></span></p>} />
                            <FormControlLabel value="完成" control={<Radio />} label={<p>完成<span style={{color: 'red'}}></span></p>} />
                            <FormControlLabel value="作废" control={<Radio />} label={<p>作废<span style={{color: 'red'}}></span></p>} />
                        </RadioGroup>
                    </FormControl>
                </Grid>
                <Grid container spacing={8}>
                    <FormControl component="fieldset" className={classes.formControl}>
                        <RadioGroup
                            name="type"
                            className={classes.group}
                            value={query.type}
                            onChange={(e) => this.changeQuery(e,'type')}
                        >
                            <FormControlLabel value="" control={<Radio checked={!query.type} />} label={<p>全部<span style={{color: 'red'}}></span></p>} />
                            <FormControlLabel value="普通" control={<Radio />} label={<p>普通<span style={{color: 'red'}}></span></p>} />
                            <FormControlLabel value="紧急" control={<Radio />} label={<p>紧急<span style={{color: 'red'}}></span></p>} />
                        </RadioGroup>
                    </FormControl>
                </Grid>
                <Grid container spacing={8}>
                    {filterList.filter(item => item.isShow).map((item, index) => {
                        return (
                            <EnhancedFilterField
                                item={item}
                                value={query[item.value]}
                                key={index}
                                onHandleQuery={(e) => this.changeQuery(e, item.value)}
                                onCancel={this.cancelFiltersClick}
                            />
                        );
                    })}
                </Grid>
                <Paper className={classes.root}>
                    {list.length === 0 && <NoData />}
                    {list.length > 0 && <Table className={classes.table}>
                        <TableHead>
                            <TableRow>
                                <TableCell>ID</TableCell>

                                <TableCell>问题描述</TableCell>

                                <TableCell style={{maxWidth: 200}}>创建人</TableCell>

                                <TableCell style={{maxWidth: 200}}>执行人</TableCell>
                                
                                <TableCell style={{maxWidth: 400}}>类型</TableCell>

                                <TableCell>状态</TableCell>
                                
                                <TableCell>截至日期</TableCell>
                                
                                {(permissionMap['待办事项_修改'] || permissionMap['待办事项_删除']) && <TableCell>操作</TableCell>}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {list.map(row => {
                                const tmp = document.createElement("DIV");
                                tmp.innerHTML = row.answer;
                                return (
                                    <TableRow key={row.id}>
                                        <TableCell>{row.id}</TableCell>
                                        <TableCell>
                                            <TableCell style={{maxWidth: 400, wordBreak: 'break-all'}} dangerouslySetInnerHTML={{__html: row.described}}></TableCell>
                                        </TableCell>
                                        <TableCell>{row.accountName}</TableCell>
                                        <TableCell>{row.currentAccountName}</TableCell>
                                        
                                        <TableCell style={{maxWidth: 200, wordBreak: 'break-all'}}>{row.type}</TableCell>
                                        
                                        <TableCell>{row.status}</TableCell>

                                        <TableCell>{dateFormat(new Date(row.dueTime))}</TableCell>
                                        
                                        {(permissionMap['待办事项_修改'] || permissionMap['待办事项_删除']) && <TableCell>
                                            
                                            {permissionMap['待办事项_修改'] && <Tooltip title="修改">
                                                <IconButton color="primary" onClick={()=>dispatch(actions.showUpdateModal(row.id))}><ModeEditIcon /></IconButton>
                                            </Tooltip>}
                                            {permissionMap['待办事项_删除'] && <Tooltip title="删除">
                                                <IconButton color="secondary" onClick={() => dispatch({type: actions.SHOW_MODAL,key: 'delete', id: row.id})}><ClearIcon /></IconButton>
                                            </Tooltip>}
                                        </TableCell>}
                                    </TableRow>
                                )
                            })}
                        </TableBody>
                        <TableFooter>
                            <Pagination 
                                total={total}
                                {...page}
                                onPageClick={this.onPageClick}
                            />
                        </TableFooter>
                    </Table>}
                </Paper>
                {showModal.add && <AddFormDialog {...this.props} onSubmit={(formData)=>dispatch(actions.add(formData))}/>}
                {showModal.update && <UpdateFormDialog {...this.props} onSubmit={(formData)=>dispatch(actions.update(formData))} />}
                {showModal.delete && <DeleteDialog {...this.props} />}
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        ...state.todoTask,
        permissionMap: state.auth.user.permissionMap
    }
}

export default connect(mapStateToProps)(withStyles(styles)(TodoTask))


// WEBPACK FOOTER //
// ./src/pages/home/routes/todo_task/components/list.js